<template>
    <div style="padding: 15px;height: 100vh">
        <div v-if="render_type == 'all'" class="app-content">
            <a-card title="จัดการแจ้งเบิก">
                <template #extra>
                    <a-space>
                        <router-link :to="`/app/withdrawUser/add`">
                            <a-button style="display: flex;"
                                type="primary" size="large">
                                <template #icon><span class="material-symbols-outlined">Add</span></template>
                                    สร้างคำขอเบิก
                            </a-button>
                        </router-link>
                    </a-space>
                </template>

                <a-row>
                    <a-space>
                        <a-range-picker v-model:value="timeStart" />
                    </a-space>
                    <a-button @click="clear_search" type="dashed" style="margin-left: 1rem">CLEAR</a-button>
                </a-row>

                <br>
                <a-row>
                    <a-table :columns="filteredColumns" :data-source="filtered_list(show_table_list)" bordered size="small" :scroll="{ x: 'calc(100px + 50%)', y: '100%' }">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'withdraw_user_timestamp'">
                                <div> {{ render_date(record.withdraw_user_timestamp) }} </div>
                            </template>
                            <template v-if="column.key === 'time_start'">
                                <div> {{ render_date(record.time_start) }} </div>
                            </template>
                            <template v-if="column.key === 'withdraw_user_no'">
                                <div> {{record.withdraw_user_no}} </div>
                            </template>
                            <template v-if="column.key === 'claim_type_id'">
                                <div> {{ getLeavePatternTypeName(record.claim_type_id) }} </div>
                            </template>
                            <template v-if="column.key === 'leave_user_amount'">
                                <div> {{record.leave_user_amount}} </div>
                            </template>
                            <template v-if="column.key === 'claim_status_id'">
                                <div> {{getClaimTypeName(record.claim_status_id)}} </div>
                            </template>
                            <template v-if="column.key === 'withdraw_user_amount'">
                                <div> {{Number(record.withdraw_user_amount).toLocaleString() }} </div>
                            </template>
                            <template v-if="column.key === 'withdraw_user_remark'">
                                <div> {{record.withdraw_user_remark}} </div>
                            </template>
                            <template v-if="column.key === 'id'">
                                <div>
                                    <a @click="send_leave_user(record.id)" 
                                        :style="{ 
                                            pointerEvents: 
                                            record.claim_status_id !== 0
                                                ? 'none' 
                                                : 'auto' 
                                        }"
                                    >
                                        <span 
                                            :style="{ fontSize: '18px', color: record.claim_status_id !== 0 ? 'gray' : 'inherit' }" 
                                            class="material-symbols-outlined">
                                            Send
                                        </span>
                                    </a>
                                    <a-divider type="vertical"></a-divider>
                                    <router-link :to="`/app/withdrawUser/${record.id}`">
                                        <span style="font-size: 14px"
                                            class="material-symbols-outlined">drive_file_rename_outline</span>
                                    </router-link>
                                    <a-divider type="vertical"></a-divider>
                                    <a @click="remove_leave_user(record.id)" 
                                        :style="{ 
                                            pointerEvents: 
                                            record.claim_status_id !== 0
                                                ? 'none' 
                                                : 'auto' 
                                        }"
                                    >
                                        <span 
                                            :style="{ fontSize: '18px', color: record.claim_status_id !== 0 ? 'gray' : 'inherit' }" 
                                            class="material-symbols-outlined">
                                            delete
                                        </span>
                                    </a>
                                </div>
                            </template>
                        </template>
                    </a-table>
                </a-row>
            </a-card>
        </div>

        <div v-else-if="render_type != 'all'" class="app-content">
            <a-card :title="render_type == 'add' ? 'สร้างคำขอเบิก':'แก้ไขคำขอเบิก'">
                <template #extra>
                    <a-button style="display: flex" @click="$router.go(-1)" size="large">
                        <template #icon>
                            <span class="material-symbols-outlined">arrow_back_ios</span>
                        </template>
                        ย้อนกลับ
                    </a-button>
                </template>

                <a-form layout="vertical" :model="detail" name="detail-form" autocomplete="off" @finish="submitLeaveUser">
                    <a-divider orientation="left">
                        <h>ข้อมูลการแจ้งเบิก</h>
                    </a-divider>
                    <a-row type="flex">
                        <a-col :span="12">
                            <a-form-item label="วันที่แจ้งเบิก" name="withdraw_user_timestamp" :rules="[{ required: true, message: 'กรุณากรอกวันที่แจ้งเบิก' }]">
                                <a-date-picker v-model:value="detail.withdraw_user_timestamp" placeholder="วันที่แจ้งเบิก" style="width: 98%;" disabled></a-date-picker>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="วันที่ขอเบิก" name="time_start" :rules="[{ required: true, message: 'กรุณากรอกวันที่ขอเบิก' }]">
                                <a-date-picker v-model:value="detail.time_start" placeholder="วันที่ขอเบิก" style="width: 98%;" @change="validateDates" :disabled="disfieldSend"></a-date-picker>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="ประเภทการเบิกเงิน" name="claim_type_id" style="width: 98%;"
                                :rules="[{ required: true, message: 'กรุณากรอกประเภทการเบิกเงิน' }]">
                                <a-select v-model:value="detail.claim_type_id" placeholder="ประเภทการเบิกเงิน" :disabled="disfieldSend">
                                    <a-select-option
                                        v-for="({ id, name }, i) in leave_pattern_list"
                                        :key="i"
                                        :value="id"
                                        >{{ name }}
                                        </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="จำนวนเงินที่ขอเบิก" name="withdraw_user_amount" :rules="[{ required: true, message: 'กรุณากรอกจำนวนเงินที่ขอเบิก' }]">
                                <a-input v-model:value="detail.withdraw_user_amount" placeholder="จำนวนเงินที่ขอเบิก" type="number" :disabled="disfieldSend"></a-input>
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <a-divider orientation="left">
                        <h>เหตุผลการขอเบิก</h>
                    </a-divider>
                        <a-form-item name="withdraw_user_remark">
                            <a-textarea v-model:value="detail.withdraw_user_remark" placeholder="เหตุผลการขอเบิก" :rows="2" :disabled="disfieldSend"></a-textarea>
                        </a-form-item>
                    <a-divider orientation="left">
                        <h>รูปหลักฐานการโอน (ผู้แจ้งเบิก)</h>
                    </a-divider>

                    <div v-if="detail.photo_1 != null && detail.photo_1 != ''" class="image-container">
                        <img :src="detail.photo_1" class="uploaded-image-table" alt="uploaded image" />
                        <div class="icon-container">
                            <span class="material-symbols-outlined preview-icon" @click="showPreview($event, detail.photo_1)">
                                visibility
                            </span>
                            <!-- <span class="material-symbols-outlined download-icon"
                                @click="getBase64Image($event, detail.photo_1)">
                                download
                            </span> -->
                            <!-- <span v-if="detail.send_status != 1" class="material-symbols-outlined download-icon"
                                @click="remove_uploaded_file">
                                Delete
                            </span> -->
                        </div>
                    </div>

                    <a-upload 
                        v-else
                        :disabled="true"
                        v-model:file-list="fileList" 
                        list-type="picture-card"
                        class="avatar-uploader"
                        name="photo_1"
                        :action="upload_files"
                        method="GET"
                        @remove="remove_uploaded_file">
                        <div style="height: 104px; width: 104px; padding: 2rem">
                            <span style="font-size: 20px" class="material-symbols-outlined">add</span>
                            <div style="margin-top: 8px">Upload</div>
                        </div>
                    </a-upload>

                    <!-- <a-upload 
                        v-model:file-list="fileList" 
                        list-type="picture-card"
                        class="avatar-uploader"
                        name="photo_1"
                        :action="upload_files"
                        method="GET"
                        @remove="remove_uploaded_file">
                        <div v-if="!detail.photo_1" style="height: 104px; width: 104px; padding: 2rem">
                            <span style="font-size: 20px" class="material-symbols-outlined">add</span>
                            <div style="margin-top: 8px">Upload</div>
                        </div>
                    </a-upload> -->
               
                    <!-- <a-upload 
                        v-model:file-list="fileList"
                        list-type="picture-card"
                        name="photo"
                        class="avatar-uploader"
                        method="GET" accept="image/png, image/jpeg, image/jpg"
                        style="max-height: 200px"
                        :action="upload_files"
                        :showUploadList="false">
                        <img v-if="detail.photo_1" :src="detail.photo_1" style="max-height: 100px" alt="photo"/>
                        <div v-if="!detail.photo_1" style="height: 104px; width: 104px; padding: 2rem">
                            <span style="font-size: 20px" class="material-symbols-outlined">add</span>
                            <div style="margin-top: 8px">Upload</div>
                        </div>
                    </a-upload> -->

                    <a-divider orientation="left">
                        <h>หมายเหตุ ( ผู้แจ้งเบิก )</h>
                    </a-divider>

                    <a-form-item name="withdraw_admin_remark">
                        <a-textarea v-model:value="detail.withdraw_admin_remark" placeholder="หมายเหตุ" :rows="2" :disabled="true"></a-textarea>
                    </a-form-item>

                    <a-row justify="end">
                        <a-col>
                            <a-button type="primary" html-type="submit" size="large"
                                style="margin: 4px;text-align: right">
                                    <span class="material-symbols-outlined" style="font-size: 16px;margin-right: 4px">Edit</span>
                                    บันทึกข้อมูล
                            </a-button>
                        </a-col>
                    </a-row>
                </a-form>
            </a-card>
        </div>


    </div>
</template>

<script>
import Utility from '../../utility'
import Swal from 'sweetalert2'
import SystemService from '../../api/SystemService'
import AdminService from '../../api/AdminService';
import UserService from '../../api/UserService';
import LeaveUserService from '../../api/LeaveUserService';
import dayjs from 'dayjs'
import 'dayjs/locale/th'
import { message } from "ant-design-vue";
import { h } from 'vue';
import CompanyService from '../../api/CompanyService'
import LeaveService from '../../api/LeaveService';
import WithdrawUserService from '../../api/WithdrawUserService';
dayjs.locale('th');

export default {
    name: 'LeaveUser',
    computed: {
        leave_quota_limits() {
            return this.businessTypeId == 4
                ? {
                    1: 7,  // ลากิจ: 7 ครั้ง/ปี
                    2: 12,  // ลาพักร้อน: 12 ครั้ง/ปี
                    4: 30, // ลาป่วย: 30 ครั้ง/ปี
                    6: null, // ลาชาปนกิจ: ไม่มีเงื่อนไข
                }
                : {
                    1: 3,  // ลากิจ: 3 ครั้ง/ปี
                    2: 8,  // ลาพักร้อน: 8 ครั้ง/ปี
                    7: 4,  // ลาฝึกอบรม: 4 ครั้ง/ปี
                    4: 30, // ลาป่วย: 30 ครั้ง/ปี
                    5: null, // ลาแบบไม่รับค่าจ้าง: ไม่มีเงื่อนไข
                    6: null, // ลาชาปนกิจ: ไม่มีเงื่อนไข
                };
        },
        render_type() {
            this.clear_withdraw_user()
            if(this.$route.params.type != 'add' && this.$route.params.type != 'all'){
                this.init_edit_leave_user()
            }
            return this.$route.params.type
        },
        filteredColumns() {
            if (Array.isArray(this.columns)) {
                return this.columns.filter(column => {
                    if(this.businessTypeId != 3 && this.businesssTypeId != 2){
                        return column.key !== 'leave_pattern_id'
                    }
                    return column.key !== 'leave_quota' || this.business;
                });
            }
            return [];
        
        },
    },
    data() {
        return {
            leave_quota_data: [], // ดึงข้อมูลโควตาจาก API
            isLeaveUserSent: false,
            businessTypeId:null,
            leave_pattern_list:[
                {id: 1, name:'เงินสด'},
                {id: 2, name:'เงินโอน'},
            ],
            previewImage: "",
            previewVisible: false,
            previousTimeEnd: null,
            create_leave_user: [],
            create_photo: [],
            dataById: null,
            detail: {
                // id: null,
                // leave_type_id: null,
                // leave_pattern_id:null,
                // leave_quota: null,
                // leave_user_no: null,
                withdraw_user_timestamp: dayjs(),
                // time_start: null,
                // time_end: null,
                // leave_user_amount: null,
                // leave_user_remark: null,
                // company_id: null,
                claim_status_id: 0,
                // user_name: null,
                // fullname: null,
                // photo_1: null,
                // photo_2: null,
                // photo_3: null,
                // photo_4: null,
                // photo_5: null,
            },
            // editable: Utility.get_permission_editable_with_key('leave_user'),
            timeStart: null,
            timeEnd: null,
            leave_types: [],
            business: false,
            filtered_leave_types: [],
            loading: false,
            search_business_type: null,
            img_placeholder: require('@/assets/images/place-holder/placeholder.jpg'),
            show_table_list: [],
            selected_leave_user: null,
            fileList: [],
            input: 'Username / ชื่อบริษัท',
            search_input: null,
            disfieldSend: false,
            columns: [
                {
                    title: 'วันที่แจ้งเบิก',
                    dataIndex: 'withdraw_user_timestamp',
                    key: 'withdraw_user_timestamp',
                    width: 120,
                    align: 'center',
                },
                {
                    title: 'วันที่ขอเบิก',
                    dataIndex: 'time_start',
                    key: 'time_start',
                    width: 180,
                    align: 'center',
                }, 
                {
                    title: 'เลขกำกับใบเบิก',
                    dataIndex: 'withdraw_user_no',
                    key: 'withdraw_user_no',
                    width: 150,
                    align: 'center',
                }, 
                {
                    title: 'ประเภทการเบิกเงิน',
                    dataIndex: 'claim_type_id',
                    key: 'claim_type_id',
                    width: 120,
                    align: 'center',
                }, 
                {
                    title: 'จำนวนขอเบิก',
                    dataIndex: 'withdraw_user_amount',
                    key: 'withdraw_user_amount',
                    width: 100,
                    align: 'center',
                },
                {
                    title: 'สถานะการเบิก',
                    dataIndex: 'claim_status_id',
                    key: 'claim_status_id',
                    width: 100,
                    align: 'center',
                }, 
                {
                    title: 'หมายเหตุ',
                    dataIndex: 'withdraw_user_remark',
                    key: 'withdraw_user_remark',
                    width: 150,
                    align: 'center',
                }, 
                {
                    title: 'ตัวเลือก',
                    dataIndex: 'id',
                    key: 'id',
                    width: 130,
                    align: 'center',
                    fixed: 'right'
                }
            ],
        }
    },
    watch: {
    // 'detail.time_start': function(newVal) {
    //             console.log("🕵️‍♂️ [watch] วันที่เริ่มลาเปลี่ยน:", newVal);
    //         },
    //         'detail.time_end': function(newVal) {
    //             console.log("🕵️‍♂️ [watch] วันที่สิ้นสุดการลาเปลี่ยน:", newVal);
    //         }
        },
    methods: {
        async getBase64Image(e, file) {
            e.stopPropagation();
            e.preventDefault();

            if (typeof file === 'string') {
                const result = await this.getBase64ImageFromURL(file);
                let a = document.createElement('a');
                a.href = result;
                a.download = 'image.png';
                a.click();
            } else if (file.url) {
                const result = await this.getBase64ImageFromURL(file.url);

                // download
                let a = document.createElement('a');
                a.href = result;
                a.download = 'image.png';
                a.click();
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => {
                    const base64String = reader.result;
                    let a = document.createElement('a');
                    a.href = base64String;
                    a.download = 'image.png';
                    a.click();
                };
            }
        },
        showPreview(e, fileUrl) {
            e.stopPropagation();
            this.previewImage = fileUrl;
            this.previewVisible = true;
        },
        async getBase64ImageFromURL(url) {
            const res = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
            });
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        validateDates() {
            if (this.detail.time_start && this.detail.time_end) {
                const start = dayjs(this.detail.time_start).startOf('day');
                const end = dayjs(this.detail.time_end).startOf('day');
                // console.log("✅ [validateDates] ตรวจสอบวันที่");
                // console.log("📅 วันที่เริ่มลา:", start.format("YYYY-MM-DD"));
                // console.log("📅 วันที่สิ้นสุดการลา:", end.format("YYYY-MM-DD"));
                if (end.isBefore(start)) {
                    // console.log("❌ [Error] วันที่สิ้นสุดต้องไม่น้อยกว่าวันที่เริ่ม");
                    this.$message.error('กรุณากรอกวันที่สิ้นสุดให้มากกว่าวันที่เริ่มเบิก');
                    this.detail.time_end = null;
                } else {
                    const diffDays = end.diff(start, 'day') + 1;
                    this.detail.leave_user_amount = diffDays;
                    // console.log("✅ [Success] จำนวนวันลา:", diffDays);
                }
            }
        },
        clear_withdraw_user() {
            this.detail = {
                id: null,
                time_start: null,
                withdraw_user_timestamp: dayjs(),
                claim_type_id: null,
                withdraw_user_amount: null,
                claim_status_id: 0,
                user_name: null,
                fullname: null,
                photo_1: null,
                withdraw_admin_remark: null,
                withdraw_user_remark: null
            }
            this.create_leave_user = []
            this.create_photo = []
            this.fileList = []
            this.disfieldSend = false
        },
        async upload_files(e) {
            try {
                const base64 = await this.getBase64(e);
                this.detail.photo_1 = base64;
                const response = await fetch('https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6');
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                return response.url;
            } catch (error) {
                console.error('Error uploading files:', error);
            }
        },
        getBase64(file) {
            return new Promise((resolve, reject) =>{
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },
        async remove_uploaded_file() {
            this.fileList = [];
            this.detail.photo_1 = null
            this.onRefresh();
        },
        async remove_edit_uploaded_file({ uid }) {
            const { id } = this.detail
            this.create_leave_user[uid] = ''
            await SystemService.update_all('LeaveUser', { data: { photo_1: null } }, id);
            this.onRefresh()
        },
        onResetData(){
            //  this.detail =  {
            //     id: null,
            //     leave_type_id: null,
            //     leave_user_no: null,
            //     leave_user_timestamp: dayjs(),
            //     time_start: null,
            //     time_end: null,
            //     leave_user_amount: null,
            //     leave_user_remark: null,
            //     company_id: null,
            //     leave_user_status: 'ฉบับร่าง',
            //     user_name: null,
            //     fullname: null,
            //     photo_1: null,
            //     photo_2: null,
            //     photo_3: null,
            //     photo_4: null,
            //     photo_5: null,
            // }
        },
        async init_edit_leave_user() {
            this.selected_leave_user = await WithdrawUserService.getWithdrawUserByCompanyAndId(this.$route.params.type)
            this.detail = this.selected_leave_user[0];
            this.fileList = this.selected_leave_user
                .filter(item => item.photo_1)
                .map((item, index) => {
                    return {
                        uid: index,
                        name: item.photo_1,
                        status: 'done',
                        url: item.photo_1,
                    };
                });
            this.detail.withdraw_user_timestamp = dayjs(this.selected_leave_user[0].withdraw_user_timestamp)
            this.detail.time_start = dayjs(this.selected_leave_user[0].time_start)
            this.detail.send_status == 1 ? this.disfieldSend = true : this.disfieldSend = false
        },
        clear_search() {
            this.search_input = null;
            this.timeStart = null;
            this.timeEnd = null;
        },
        onRefresh() {
             this.init_leave_users()
        },
        remove_leave_user(id){
            Swal.fire({
                title: 'คุณต้องการลบใช่หรือไม่??',
                text: `คุณจะไม่สามารถกู้คืนได้`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ใช่',
                cancelButtonText: 'ยกเลิก'
                }).then(async (result) => {
                if (result.isConfirmed) {
                    await SystemService.delete_all('WithdrawUser', id)
                    this.onRefresh()
                }
            })
        },
        async send_leave_user(id) {
            try {
                const leaveUserData = await WithdrawUserService.getWithdrawUserByCompanyAndId(id);
                await SystemService.update_all('WithdrawUser', { data: { claim_status_id: 1, send_status: 1, approved_date: dayjs().format('YYYY-MM-DD HH:mm:ss') } }, id);
                const selectedData = {
                    withdraw_user_id: leaveUserData[0].id,
                    user_name: leaveUserData[0].user_name,
                    withdraw_user_timestamp: this.render_date(leaveUserData[0].withdraw_user_timestamp),
                    time_start: this.render_date(leaveUserData[0].time_start),
                    withdraw_user_no: leaveUserData[0].withdraw_user_no,
                    claim_type_id: leaveUserData[0].claim_type_id,
                    withdraw_user_amount: leaveUserData[0].withdraw_user_amount,
                    withdraw_user_remark: leaveUserData[0].withdraw_user_remark,
                    fullname: leaveUserData[0].fullname,
                    photo_1: leaveUserData[0].photo_1,
                    photo_2: leaveUserData[0].photo_2,
                    photo_3: leaveUserData[0].photo_3,
                    photo_4: leaveUserData[0].photo_4,
                    photo_5: leaveUserData[0].photo_5,
                    // leave_progress: 1,
                    created_at: dayjs().format("YYYY/MM/DD HH:mm"),
                    company_id: leaveUserData[0].company_id,
                };
                await SystemService.create_all('WithdrawAdmin', { data: [selectedData] });

                message.success("ส่งการแจ้งเบิกสำเร็จ");
                this.isLeaveUserSent = true;
                this.onRefresh();
            } catch (error) {
                console.error("Error sending leave user:", error);
                message.error("เกิดข้อผิดพลาดในการส่งการแจ้งเบิก");
            }
        },
        async edit_leave_user(id){
            this.$router.push(`/app/leaveUser/edit/${id}`)
        },
        getLeaveTypeName(id) {
            const leaveType = this.leave_types.find(type => type.id === id);
            return leaveType ? leaveType.name : '';
        },
        getLeavePatternTypeName(id) {
            const leaveType = this.leave_pattern_list.find(type => type.id === id);
            return leaveType ? leaveType.name : '';
        },
        getClaimTypeName(id) {
            if(!id){
                return 'ฉบับร่าง'
            }
            if(id == 1){
                return 'รออนุมัติ'
            }
            if(id == 2){
                return 'อนุมัติ'
            }
            if(id == 3){
                return 'ไม่อนุมัติ'
            }
        },
        filtered_list(array) {
            return array.filter(({ name, time_start, time_end }) => {
                let matchesName = true;
                let matchesDateRange = true;
                if (this.search_input) {
                    matchesName = name?.toLowerCase().includes(this.search_input.toLowerCase());
                }
                // ตรวจสอบช่วงวันที่ (ไม่สนใจเวลา)
                if (this.timeStart) {
                    const filterStart = dayjs(this.timeStart[0]).startOf('day');
                    const filterEnd = dayjs(this.timeStart[1]).endOf('day');
                    const target = dayjs(time_start);
                    matchesDateRange = target.isSameOrAfter(filterStart) && target.isSameOrBefore(filterEnd);
                }
                return matchesName && matchesDateRange;
            });
        },
        async init_leave_users() {
            try {
                const companyData = localStorage.getItem('companyData');
                if (!companyData) {
                    console.error("Missing company data in localStorage");
                    return;
                }
                const company_id = JSON.parse(companyData).id;
                this.show_table_list = await WithdrawUserService.getWithdrawUserByCompany();
                if (!this.show_table_list || !Array.isArray(this.show_table_list)) {
                    console.error("show_table_list is undefined or not an array.");
                    return;
                }
            } catch (error) {
                console.error(" Error initializing leave users:", error);
            }
        },
        render_date(datetime) {
            return dayjs(datetime).format('YYYY/MM/DD')
        },
        async submitLeaveUser() {
            if (this.$route.params.type != 'add') {
                return this.submitUpdateLeaveUser()
            }
            const hideLoading = message.loading({
                content: "กำลังบันทึกข้อมูล...",
                key: "detail",
                duration: 0, 
            });
            if (this.fileList) {
                for (var i = 0; i < this.fileList.length; i++) {
                    const target = this.fileList[i];
                    this.detail['photo_' + (i + 1)] = await this.getBase64(target.originFileObj);
                }
            }
            this.detail.company_id = JSON.parse(localStorage.getItem('companyData')).id;
            this.detail.user_name = JSON.parse(localStorage.getItem('user_profile')).username;
            this.detail.fullname = JSON.parse(localStorage.getItem('user_profile')).fullname;
            await SystemService.create_all('WithdrawUser', { data: [this.detail] });
            hideLoading();
            Swal.fire(
                'เพิ่มคำขอแจ้งเบิกสำเร็จ!',
                'เพิ่มคำขอแจ้งเบิกสำเร็จแล้ว',
                'success'
            );
            this.onResetData();
            this.$router.go(-1);
            this.onRefresh();
        },
        async submitUpdateLeaveUser() {
            const { id } = this.detail
            this.detail.company_id = JSON.parse(localStorage.getItem('companyData')).id
            this.detail.user_name = JSON.parse(localStorage.getItem('user_profile')).username
            await SystemService.update_all('WithdrawUser', { data: this.detail }, id)
            hideLoading()
            Swal.fire(
                'เพิ่มคำขอแจ้งเบิกสำเร็จ!',
                'เพิ่มคำขอแจ้งเบิกสำเร็จแล้ว',
                'success'
            )
            this.onResetData()
            this.$router.go(-1)
            this.onRefresh()
        },

        async get_company() {
			const company = await UserService.get_user_profile();
            const businessType = await CompanyService.getBusinessId(company.company_id)
            if ( businessType.data === 2 || businessType.data === 3 || businessType.data === 4)
            {
                this.business = true
            }
        },
        async get_businessType() {
            const company = await UserService.get_user_profile();
            const businessType = await CompanyService.getBusinessId(company.company_id)
            this.businessTypeId = businessType.data
        },
    async updateLeaveQuota() {
        if (this.detail.leave_type_id) {
            if(this.detail.leave_user_status == "อนุมัติ"||this.detail.leave_user_status == "ไม่อนุมัติ"){
                const leaveQuotaData = await SystemService.leavequotaused(this.detail.company_id,this.detail.user_name,this.detail.leave_user_no);
                this.leave_quota_data = leaveQuotaData.data
            }else{
                const company_id = JSON.parse(localStorage.getItem('companyData')).id;
                const username = JSON.parse(localStorage.getItem('user_profile')).username;
                const response = await SystemService.leavequota(company_id, username);
                this.leave_quota_data = response.data;
            }
            const quota = this.leave_quota_data.find(
                (item) => item.leave_type_id === this.detail.leave_type_id
            );
            const usedQuota = quota ? quota.count : 0; // จำนวนที่ใช้ไป
            const totalQuota = this.leave_quota_limits[this.detail.leave_type_id]; // โควตาทั้งหมด

            if (totalQuota !== null) {
                this.detail.leave_quota = `${usedQuota}/${totalQuota}`; // เช่น "1/3"
            } else {
                this.detail.leave_quota = `-`; // ไม่มีเงื่อนไข
            }
        }
    },
    },
//     watch: {
//     'detail.leave_type_id': function () {
//         this.updateLeaveQuota();
//     },
// },



    async mounted() {
        // console.log('5678',this.editable);
        await this.get_businessType();
        this.init_leave_users().then(() => {
        this.get_company().then(() => {
        });
    });
    }
}
</script>

<style>
.preview-icon,
.download-icon {
    cursor: pointer;
    font-size: 2px;
    color: black;
}
.image-container {
    position: relative;
    display: inline-block;
}
.uploaded-image-table {
    display: block;
    width: 20rem;
    height: auto;
}
.icon-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    padding: 5px;
}

.permission-table .ant-table-row-level-0 td:first-child,
.permission-table .ant-table-row-level-0 td:nth-child(2),
.permission-table .ant-table-row-level-0 td:nth-child(3) {
    background-color: #f9f9f9 !important;
}
.permission-table .ant-table-row-expand-icon::before,
.permission-table .ant-table-row-expand-icon::after 
{
    content: '' !important;
    border: none !important;
    background: none; /* ปิด background */
    transform: none !important;
    transition: none !important;
    top: auto !important
}
.permission-table .ant-table-row-expand-icon:not(.ant-table-row-expand-icon-expanded)::before {
    content: '>' !important;
}

.permission-table .ant-table-row-expand-icon.ant-table-row-expand-icon-expanded::before {
    content: 'v' !important;
}
</style>